import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'

import { accessRole } from "../../../../helpers/access_role"
import CustomSelect from '../../GlobalComponents/CustomSelect'

const createYearOption = (startYear = 2000) => {
    var currentYear = new Date().getFullYear(), years = [];
      startYear = startYear || 1980;  
      while ( startYear <= currentYear ) {
          var newObj = {};
          var year = startYear++;
          newObj["label"] = year;
          newObj["value"] = year;
          years.push(newObj);
      }   
      return years;
  }
var reformatRank = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.rank_name;
      newObj["value"] = region.rank_uuid;
  
      return newObj;
    });
}
var reformatRankType = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.rank_type_name;
      newObj["value"] = region.rank_type_id;
  
      return newObj;
    });
}
var reformatRank = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.rank_name;
      newObj["value"] = region.rank_uuid;
  
      return newObj;
    });
  };


  var reformatOptionWorkUnit = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.work_unit_name;
      newObj["value"] = region.work_unit_uuid;
      return newObj;
    });
  };

  
class IndexView extends Component {

    createBloc = new CreateBloc();

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")
    peg_nip = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_nip : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_nip : "")

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            rankItems : [],
            ranktypeItems : [],
            rankFormSelected: "",
            yearOptions: createYearOption(new Date().getFullYear() - 100),
        }
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, 'file')
        await this.createBloc.fetchCreate(dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                peg_nip: this.peg_nip,
              employee_uuid : this.peg_uuid,
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        // console.log(this.employeeSeleted);
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.rankChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        
                        this.setState({
                            rankItems: reformatRank(response)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.rankTypeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        
                        this.setState({
                            ranktypeItems: reformatRankType(response)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
       
        this.createBloc.fetchRank()
        this.createBloc.fetchRankType()
        

    }

    

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="riwayat_pangkat"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Tambah Riwayat Pangkat</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pangkat <span className="text-danger">*</span>
                                            </label>
                                                    
                                            <Col md="5">
                                            <CustomSelect 
                                                    name={`pangkat`}
                                                    errorMessage="Pilih Pangkat"
                                                    options={this.state.rankItems} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Pangkat"
                                                    // isLoading={this.state.isLoadingOptEmployee}
                                                    // onChange={
                                                    //     (v) => this.setState({
                                                    //         selectedEmployee: v.model
                                                    //     })
                                                    // }
                                                    // defaultValue={data.type}
                                            />

                                            </Col>        

                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tipe Pangkat <span className="text-danger">*</span>
                                            </label>
                                                    
                                            <Col md="5">
                                            <CustomSelect 
                                                    name={`rank_type`}
                                                    errorMessage="Pilih Tipe Pangkat"
                                                    options={this.state.ranktypeItems} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Tipe Pangkat"
                                                    // isLoading={this.state.isLoadingOptEmployee}
                                                    // onChange={
                                                    //     (v) => this.setState({
                                                    //         selectedEmployee: v.model
                                                    //     })
                                                    // }
                                                    // defaultValue={data.type}
                                            />

                                            </Col>        

                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="period"
                                                className="col-md-3 col-form-label"
                                            >
                                            Masa Kerja Tahun <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                {/* <CustomSelect 
                                                    name="period"
                                                    errorMessage="Pilih Tahun Lulus"
                                                    options={this.state.yearOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Periode"
                                                    defaultValue={new Date().getFullYear()}
                                                /> */}
                                                <AvField
                                                    name="period"
                                                    placeholder="Masa Kerja Tahun..."
                                                    type="number"
                                                    errorMessage="Masukkan Masa Kerja Tahun"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="period"
                                                    // value={this.state.detail.rank_history_year_period}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="period_month"
                                                className="col-md-3 col-form-label"
                                            >
                                            Masa Kerja Bulan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <AvField
                                                    name="period_month"
                                                    placeholder="Masa Kerja Bulan..."
                                                    type="number"
                                                    errorMessage="Masukkan Masa Kerja Bulan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="period_month"
                                                    // value={this.state.detail.rank_history_month_period}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            No SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="no_sk"
                                                    placeholder="Nomor SK..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor SK"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="no_sk"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="tanggal_sk"
                                                    placeholder="Tanggal SK..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal SK"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="tanggal_sk"
                                                />
                                            </Col>
                                        </Row>

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Jabatan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <Select
                                                    value={this.state.positionItems.filter(option => 
                                                      option.value === this.state.PositionSelected)}
                                                    onChange={
                                                      this.onChangePosition
                                                    }
                                                    required="required"
                                                    options={this.state.positionItems}
                                                    classNamePrefix=""
                                                />

                                                <AvField
                                                    name="position_id"
                                                    placeholder="Nama Jabatan..."
                                                    type="hidden"
                                                    errorMessage="Masukkan Nama Jabatan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="position_id"
                                                    value={this.state.PositionSelected}
                                                />
                                            </Col>
                                        </Row> */}

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            TMT Pangkat <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="tmt_jabatan"
                                                    placeholder=" TMT Pangkat..."
                                                    type="date"
                                                    errorMessage="Masukkan  TMT Pangkat"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="tmt_jabatan"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                                Upload File SK KP <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <FileInput
                                                    name="file"
                                                    placeholder="Upload File SK KP"
                                                    className="form-control"
                                                    col="6"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?riwayat_pangkat">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?riwayat_pangkat'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView